<script setup lang="ts">
import Avatar from '@/components/common/ui/Avatar.vue'

defineProps({
  email: String,
  name: String,
})
</script>

<template>
  <div class="flex items-center rounded-full border p-1 max-w-72 fade-in" v-if="name || email">
    <Avatar :email="email" />
    <p class="mx-4 line-clamp-2">{{ name }}</p>
  </div>
</template>
